import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./styles.css";
// import dashboard from "../../Assets/Icons/icondashboard.png";
import patients from "../../Assets/Icons/iconpatients.png";
import messages from "../../Assets/Icons/icon_messages.png";
// import appointments from "../../Assets/Icons/icon_appointments.png";
// import calendar from "../../Assets/Icons/icon_calendar.png";
// import doctors from "../../Assets/Icons/icon_doctors.png";
// import other from "../../Assets/Icons/icon_other_stuff.png";
import logoutIcon from "../../Assets/Icons/icon_logout.png";
import arrow from "../../Assets/Icons/icon_side_arrow.png";
import { logout as logoutService } from "../../Services";
import { useAuth } from "../../Context/AuthContext";
import { jwtDecode } from "jwt-decode";

const SideMenu = () => {
  const { user, logout } = useAuth();
  // state to keep selected menu item
  const [selectedMenuId, setSelectedMenuId] = useState(2);
  const navigate = useNavigate();

  // console.log(selectedMenuId, "selected menu id");

  //Function to handle the logout
  const handleLogout = async () => {
    try {
      const email = jwtDecode(user.token).email;
      await logoutService(email);
      logout();
      navigate("/");
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  // const showDashboard = async () => {
  //   //Show all the patients
  //   navigate("/dashboard");
  // };

  const showMessages = async () => {
    //Show all the patients
    navigate("/dashboard/messages");
  };

  // const showDoctors = async () => {
  //   //Show all the patients
  //   navigate("/dashboard/doctors");
  // };

  const showPatients = async () => {
    //Show all the patients
    navigate("/dashboard");
  };

  //Function to update the selected menu item state and then call the function corresponding to that menu item
  const handleMenuItemClick = (id, fn) => {
    setSelectedMenuId(id);

    if (fn) {
      fn();
    }
  };

  const sideMenu = [
    // { id: 1, name: "Dashboard", icon: dashboard, method: showDashboard },
    { id: 2, name: "Patients", icon: patients, method: showPatients },
    { id: 3, name: "Messages", icon: messages, method: showMessages },
    // Disabled for phase 1
    // { id: 4, name: "Appointments", icon: appointments },
    // { id: 5, name: "Calendar", icon: calendar },
    // { id: 6, name: "Doctors", icon: doctors, method: showDoctors  },
    // { id: 7, name: "Other Stuff", icon: other },
    { id: 8, name: "Logout", icon: logoutIcon, method: handleLogout },
  ];

  return (
    <div id="side-menu-section">
      {sideMenu.map((item, index) => (
        <div
          className={
            item.id === selectedMenuId
              ? "container4 bg-off-white p-15"
              : "container4 p-15"
          }
          key={index}
          onClick={() => handleMenuItemClick(item.id, item.method)}
        >
          <div className="flex-row-start">
            <img src={item.icon} alt="menu icon" />
            <div
              className={
                item.id === selectedMenuId
                  ? "section-subheading-text text-blue text-400"
                  : "section-subheading-text text-med-grey text-400"
              }
            >
              {item.name}
            </div>
          </div>
          <img src={arrow} id="side-arrow" />
        </div>
      ))}
    </div>
  );
};

export default SideMenu;
